import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const commentModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type CommentModalProviderProps = {
  commentModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const CommentModalProvider = ({ commentModalRef, children }: CommentModalProviderProps) => {
  return (
    <commentModalContext.Provider value={commentModalRef}>{children}</commentModalContext.Provider>
  )
}

const useCommentModal = () => {
  return useContext(commentModalContext)
}

export { CommentModalProvider, useCommentModal }
